/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Table,
  Space,
  Drawer,
  Button,
  Tooltip,
  Modal,
  Form,
  Input,
  Select,
  message,
  Switch,
  Checkbox,
  Row,
  Col,
} from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useAtom } from "jotai";
import {
  userRole,
  userTutorCityAccess,
  userStudentCityAccess,
  userShadowTutorCityAccess,
  userStudentCityAssignmentAccess,
  userTutorCityAssignmentAccess,
} from "../states/userRole";
import { citysList } from "../states/citys";
import axios from "../axios";
import dayjs from "dayjs";
import log from "../logger";

const { Option } = Select;

function Team() {
  const [isActive, setIsActive] = useState(true);
  const [data, setData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [rowData, setRowData] = useState({});
  const [role, _setRole] = useAtom(userRole);
  const [tutorCityAccess, _setTutorCityAccess] = useAtom(userTutorCityAccess);
  const [studentCityAccess, _setStudentCityAccess] = useAtom(userStudentCityAccess);
  const [shadowTutorCityAccess, _setShadowTutorCityAccess] = useAtom(userShadowTutorCityAccess);
  const [studentCityAssignmentAccess, _setStudentCityAssignmentAccess] = useAtom(userStudentCityAssignmentAccess);
  const [tutorCityAssignmentAccess, _setTutorCityAssignmentAccess] = useAtom(userTutorCityAssignmentAccess);
  const [citys, _setCitys] = useAtom(citysList);
  const [form] = Form.useForm();
  const [editForm, setEditForm] = useState(false);

  const fetchCreTeamData = () => {
    axios.get(`/v1/cre/teams`, { params: { isActive: isActive } }).then((res) => {
      setData(res?.data?.data || []);
    });
  };
  useEffect(() => {
    fetchCreTeamData();
    console.log("----  dependency changed  ----");
  }, [isActive]);

  useEffect(() => {
    console.log("----  initial changed  ----");
    fetchCreTeamData();
  }, []);

  useEffect(() => {
    if (rowData?.user_details) {
      const safeSplit = (val) => (val ? val.split(",").filter((v) => v !== "") : []);
      form.setFieldsValue({
        first_name: rowData?.user_details?.first_name,
        email: rowData?.user_details?.email,
        phone: rowData?.user_details?.phone,
        user_type: rowData?.user_details?.user_type,
        is_active: rowData?.user_details?.is_active,
        student: safeSplit(rowData?.access_details?.STUDENT),
        tutor: safeSplit(rowData?.access_details?.TUTOR),
        shadow_tutor: safeSplit(rowData?.access_details?.SHADOW_TUTOR),
        student_city_assignment: safeSplit(rowData?.access_details?.STUDENT_CITY_ASSIGNMENT),
        tutor_city_assignment: safeSplit(rowData?.access_details?.TUTOR_CITY_ASSIGNMENT),
        online_tutor_city: [1, "1", true, "true"].includes(
          rowData?.access_details?.ONLINE_TUTOR_CITY || rowData?.access_details?.online_tutor_city,
        ),
        online_tutor_assignment: [1, "1", true, "true"].includes(
          rowData?.access_details?.ONLINE_TUTOR_ASSIGNMENT || rowData?.access_details?.online_tutor_assignment,
        ),
      });
    }
  }, [rowData, form]);

  const columns = [
    {
      title: "Created At",
      dataIndex: "user_details",
      key: "created_at",
      width: 100,
      render: (_, record) =>
        record?.user_details?.created_at ? dayjs(record.user_details.created_at).format("DD-MMM-YYYY") : "",
    },
    {
      title: "Name",
      dataIndex: "user_details",
      key: "name",
      width: 120,
      render: (_, record) => (
        <div style={{ cursor: "pointer" }}>
          <Tooltip
            placement="bottomLeft"
            title={record?.user_details?.first_name}
            onClick={() => {
              if (record?.user_details?.user_type === "Superviser" || role === "Superadmin") {
                setVisible(true);
                setRowData(record);
              }
            }}
            style={{ cursor: "pointer" }}
          >
            {record?.user_details?.first_name}
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "user_details",
      key: "email",
      ellipsis: {
        showTitle: false,
      },
      width: 250,
      render: (_, record) => (
        <Tooltip placement="topLeft" title={record?.user_details?.email}>
          {record?.user_details?.email}
        </Tooltip>
      ),
    },
    {
      title: "Phone Number",
      dataIndex: "user_details",
      key: "phone",
      width: 130,
      render: (_, record) => record?.user_details?.phone,
    },
    {
      title: "User Type",
      dataIndex: "user_details",
      key: "user_type",
      width: 100,
      render: (_, record) => record?.user_details?.user_type,
    },
    {
      title: "Parents City Access",
      dataIndex: "access_details",
      key: "student",
      ellipsis: {
        showTitle: false,
      },
      width: 210,
      render: (_, record) => {
        const studentCitysIds = record?.access_details?.STUDENT?.split(",");
        return (
          <Tooltip
            placement="topLeft"
            title={Object.keys(citys)
              ?.filter((city_id) => studentCitysIds?.includes(city_id))
              ?.map((city_id) => citys[city_id])
              ?.join(", ")}
          >
            {Object.keys(citys)
              .filter((city_id) => studentCitysIds?.includes(city_id))
              .map((city_id) => citys[city_id])
              .join(", ")}
          </Tooltip>
        );
      },
    },
    {
      title: "Tutors City Access",
      dataIndex: "access_details",
      key: "tutor",
      ellipsis: {
        showTitle: false,
      },
      width: 210,
      render: (_, record) => {
        const tutorCitysIds = record?.access_details?.TUTOR?.split(",");
        return (
          <Tooltip
            placement="topLeft"
            title={Object.keys(citys)
              ?.filter((city_id) => tutorCitysIds?.includes(city_id))
              ?.map((city_id) => citys[city_id])
              ?.join(", ")}
          >
            {Object.keys(citys)
              .filter((city_id) => tutorCitysIds?.includes(city_id))
              .map((city_id) => citys[city_id])
              .join(", ")}
          </Tooltip>
        );
      },
    },
    {
      title: "Student City Assignment",
      dataIndex: "access_details",
      key: "student_city_assignment",
      ellipsis: {
        showTitle: false,
      },
      width: 210,
      render: (_, record) => {
        const studentCityAssigmentCityIds = record?.access_details?.STUDENT_CITY_ASSIGNMENT?.split(",");
        return (
          <Tooltip
            placement="topLeft"
            title={Object.keys(citys)
              ?.filter((city_id) => studentCityAssigmentCityIds?.includes(city_id))
              ?.map((city_id) => citys[city_id])
              ?.join(", ")}
          >
            {Object.keys(citys)
              .filter((city_id) => studentCityAssigmentCityIds?.includes(city_id))
              .map((city_id) => citys[city_id])
              .join(", ")}
          </Tooltip>
        );
      },
    },
    {
      title: "Tutors City Assignment",
      dataIndex: "access_details",
      key: "tutor_city_assignment",
      ellipsis: {
        showTitle: false,
      },
      width: 210,
      render: (_, record) => {
        const tutorCityAssignmentCitysIds = record?.access_details?.TUTOR_CITY_ASSIGNMENT?.split(",");
        return (
          <Tooltip
            placement="topLeft"
            title={Object.keys(citys)
              ?.filter((city_id) => tutorCityAssignmentCitysIds?.includes(city_id))
              ?.map((city_id) => citys[city_id])
              ?.join(", ")}
          >
            {Object.keys(citys)
              .filter((city_id) => tutorCityAssignmentCitysIds?.includes(city_id))
              .map((city_id) => citys[city_id])
              .join(", ")}
          </Tooltip>
        );
      },
    },
    {
      title: "Shadow Tutor City Access",
      dataIndex: "access_details",
      key: "shadow_tutor",
      ellipsis: {
        showTitle: false,
      },
      width: 150,
      render: (_, record) => {
        const shadowTutorCitysIds = record?.access_details?.SHADOW_TUTOR?.split(",");
        return (
          <Tooltip
            placement="topLeft"
            title={Object.keys(citys)
              ?.filter((city_id) => shadowTutorCitysIds?.includes(city_id))
              ?.map((city_id) => citys[city_id])
              ?.join(", ")}
          >
            {Object.keys(citys)
              ?.filter((city_id) => shadowTutorCitysIds?.includes(city_id))
              ?.map((city_id) => citys[city_id])
              ?.join(", ")}
          </Tooltip>
        );
      },
    },
    {
      title: "Is Transfer Payment",
      dataIndex: "access_details",
      key: "is_transfer_payment",
      width: 120,
      render: (_, record) => (record?.access_details?.IS_TRANSFER_PAYMENT === "1" ? "Yes" : "No"),
    },
    ...(role === "Superadmin"
      ? [
        {
          title: "Online Tutor City Access",
          dataIndex: "access_details",
          key: "online_tutor_city",
          width: 150,
          render: (_, record) => {
            const val = record?.access_details?.ONLINE_TUTOR_CITY || record?.access_details?.online_tutor_city;
            return [1, "1", true, "true"].includes(val) ? "Yes" : "No";
          },
        },
        {
          title: "Online Tutor City Assignment",
          dataIndex: "access_details",
          key: "online_tutor_assignment",
          width: 150,
          render: (_, record) => {
            const val =
              record?.access_details?.ONLINE_TUTOR_ASSIGNMENT || record?.access_details?.online_tutor_assignment;
            return [1, "1", true, "true"].includes(val) ? "Yes" : "No";
          },
        },
      ]
      : []),
  ];

  const handleIsActiveToggle = (checked) => setIsActive(checked);
  return (
    <div>
      <Switch
        className="toggle"
        checkedChildren="Active Team Members"
        unCheckedChildren="In Active Team Members"
        checked={isActive}
        onChange={handleIsActiveToggle}
      />
      {visible && (
        <Drawer
          title={`Edit Details for ${rowData?.user_details?.first_name}`}
          width={720}
          onClose={() => setVisible(false)}
          open={visible}
        >
          <Form
            form={form}
            key={rowData?.user_details?.id}
            onFinish={(values) => {
              const safeFilter = (arr) => (Array.isArray(arr) ? arr.filter((v) => v !== "") : []);
              const accessDetails = {
                student: safeFilter(values.student),
                tutor: safeFilter(values.tutor),
                student_city_assignment: safeFilter(values.student_city_assignment),
                tutor_city_assignment: safeFilter(values.tutor_city_assignment),
                shadow_tutor: safeFilter(values.shadow_tutor),
                online_tutor_city: values.online_tutor_city,
                online_tutor_assignment: values.online_tutor_assignment,
                is_transfer_payment: values.is_transfer_payment,
              };
              const userDetails = {
                first_name: values.first_name,
                // email: values.email,
                phone: values.phone,
                // user_type: values.user_type,
                is_active: values.is_active,
              };
              if (role === "Superadmin") {
                userDetails.user_type = values.user_type;
              }
              const data = {
                user_details: userDetails,
                access_details: accessDetails,
              };

              axios
                .put(`/v1/cre/teams/${rowData?.user_details?.id}`, data)
                .then((res) => {
                  log.debug(res.data);
                  const { is_success, data, error } = res.data;
                  if (!is_success) return message.error(typeof error === "string" ? error : "Something went wrong");
                  message.success(rowData?.user_details?.first_name + " details updated successfully");
                  form.resetFields();
                  setVisible(false);
                  setRowData({});
                  fetchCreTeamData();
                })

                .catch((error) => {
                  message.error("Error updating user details");
                });
              setEditForm(false);
            }}
            initialValues={{
              first_name: rowData?.user_details?.first_name,
              email: rowData?.user_details?.email,
              phone: rowData?.user_details?.phone,
              user_type: rowData?.user_details?.user_type,
              is_active: rowData?.user_details?.is_active,
              student: rowData?.access_details?.STUDENT
                ? rowData?.access_details?.STUDENT?.split(",")?.filter((v) => v !== "")
                : [],
              tutor: rowData?.access_details?.TUTOR
                ? rowData?.access_details?.TUTOR?.split(",")?.filter((v) => v !== "")
                : [],
              shadow_tutor: rowData?.access_details?.SHADOW_TUTOR
                ? rowData?.access_details?.SHADOW_TUTOR?.split(",")?.filter((v) => v !== "")
                : [],
              student_city_assignment: rowData?.access_details?.STUDENT_CITY_ASSIGNMENT
                ? rowData?.access_details?.STUDENT_CITY_ASSIGNMENT?.split(",")?.filter((v) => v !== "")
                : [],
              tutor_city_assignment: rowData?.access_details?.TUTOR_CITY_ASSIGNMENT
                ? rowData?.access_details?.TUTOR_CITY_ASSIGNMENT?.split(",")?.filter((v) => v !== "")
                : [],
              online_tutor_city: [1, "1", true, "true"].includes(
                rowData?.access_details?.ONLINE_TUTOR_CITY || rowData?.access_details?.online_tutor_city,
              ),
              online_tutor_assignment: [1, "1", true, "true"].includes(
                rowData?.access_details?.ONLINE_TUTOR_ASSIGNMENT || rowData?.access_details?.online_tutor_assignment,
              ),
              is_transfer_payment: rowData?.access_details?.IS_TRANSFER_PAYMENT === "1",
            }}
            disabled={!editForm}
          >
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: "Please input first name!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="Email"
              name="email"
              disabled={true}
              rules={[
                {
                  type: "email",
                  message: "The input is not valid E-mail!",
                },
                {
                  required: true,
                  message: "Please input email!",
                },
              ]}
            >
              <Input disabled />
            </Form.Item>

            <Form.Item
              label="Phone"
              name="phone"
              rules={[
                {
                  required: true,
                  message: "Please input phone number!",
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              label="User Type"
              name="user_type"
              disabled={role !== "Superadmin" || !editForm}
              rules={[
                {
                  required: true,
                  message: "Please input user type!",
                },
              ]}
            >
              <Select disabled={role !== "Superadmin" || !editForm}>
                <Option value="Admin">Admin</Option>
                <Option value="Superviser">Superviser</Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="Is Active"
              name="is_active"
              rules={[
                {
                  required: true,
                  message: "Please select activity status!",
                },
              ]}
            >
              <Select>
                <Option value={1}>Active</Option>
                <Option value={0}>Inactive</Option>
              </Select>
            </Form.Item>

            <Form.Item label="Student Access" name="student">
              <Select mode="multiple" style={{ width: "100%" }}>
                {role !== "Superadmin"
                  ? studentCityAccess?.map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))
                  : Object.keys(citys).map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item label="Tutor Access" name="tutor">
              <Select mode="multiple" style={{ width: "100%" }}>
                {role !== "Superadmin"
                  ? tutorCityAccess?.map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))
                  : Object.keys(citys).map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item label="Student City Assignment" name="student_city_assignment">
              <Select mode="multiple" style={{ width: "100%" }}>
                {role !== "Superadmin"
                  ? studentCityAssignmentAccess?.map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))
                  : Object.keys(citys).map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item label="Tutor City Assignment" name="tutor_city_assignment">
              <Select mode="multiple" style={{ width: "100%" }}>
                {role !== "Superadmin"
                  ? tutorCityAssignmentAccess?.map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))
                  : Object.keys(citys).map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item label="Shadow Tutor Access" name="shadow_tutor">
              <Select mode="multiple" style={{ width: "100%" }}>
                {role !== "Superadmin"
                  ? shadowTutorCityAccess?.map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))
                  : Object.keys(citys).map((city_id) => (
                    <Option key={city_id} value={city_id}>
                      {citys[city_id]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item name="is_transfer_payment" valuePropName="checked" label="Is Transfer Payment">
              <Checkbox>
                <span>Is Transfer Payment</span>
              </Checkbox>
            </Form.Item>
            {role === "Superadmin" && (
              <Form.Item
                noStyle
                shouldUpdate={(prevValues, currentValues) => prevValues.user_type !== currentValues.user_type}
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item name="online_tutor_city" valuePropName="checked">
                      <Checkbox disabled={!editForm}>Online tutor city</Checkbox>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item name="online_tutor_assignment" valuePropName="checked">
                      <Checkbox disabled={!editForm}>Online tutor assignment</Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
              </Form.Item>
            )}

            <Form.Item>
              <Space direction="horizontal">
                <Button
                  type="primary"
                  disabled={editForm}
                  onClick={() => {
                    setEditForm(true);
                  }}
                >
                  Edit
                </Button>
                <Button
                  onClick={() => {
                    setEditForm(false);
                    setVisible(false);
                  }}
                >
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
                <Button
                  type="primary"
                  disabled={editForm}
                  onClick={() => {
                    Modal.confirm({
                      title: `Are you sure you want to reset password for ${rowData?.user_details?.first_name}?`,
                      content: "This will send an email to user with new password",
                      onOk() {
                        axios
                          .post(`/v1/cre/teams/password-reset/${rowData?.user_details?.id}`)
                          .then((res) => {
                            const { is_success, data, error } = res.data;
                            if (!is_success) {
                              message.error(error);
                              return;
                            }
                            message.success({
                              content: (
                                <div>
                                  Password: <b>{data}</b>{" "}
                                  <CopyOutlined className="copy" onClick={() => navigator.clipboard.writeText(data)} />
                                  <Button
                                    type="link"
                                    size="small"
                                    style={{
                                      padding: "3px",
                                      marginLeft: "15px",
                                    }}
                                    onClick={() => message.destroy()}
                                  >
                                    X
                                  </Button>
                                </div>
                              ),
                              // duration: 0,
                            });
                          })
                          .catch((error) => {
                            message.error("Error resetting password");
                          });
                      },
                    });
                  }}
                >
                  Reset Password
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </Drawer>
      )}
      <Table columns={columns} dataSource={data || []} style={{ margin: "20px auto", padding: "10px" }} />
    </div>
  );
}

export default Team;
